module.exports = __webpack_public_path__ + "img/top-right-logo-b.14635019.svg";